import React, { Component } from 'react'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import $ from 'jquery'
import Icon from "../../common/icon/icon.component.jsx";
const Vimeo = require('react-vimeo')
import GlobalHelper from "../../common/GlobalHelper.jsx";

class PromoModal extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            modalId: this.props.modalId || 'promo-modal',
            emailId: this.props.emailId || '',
            subject: '',
        }
        this.closeModal = this.closeModal.bind(this)
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')

    }

    closeModal(event) {
        event.preventDefault()
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(event)
        }
    }


    render() {
        return (
            <div className="modal fade"
                id={this.state.modalId}
                role="dialog"
                aria-labelledby="emailModalTitle"
                data-backdrop="static"
                data-keyboard="false"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content bg-light">
                        <div className="modal-header pb-0 pt-2 px-2 border-0">
                            <h5 className="modal-title" id="emailModalTitle">
                                <a href={'https://www.quotemachine.com?utm_medium=sample&utm_source=quote'}>
                                    <img height={'50px'} src={'/images/QuoteM_horizontal_flat.png'} />
                                </a>
                            </h5>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row justify-content-center">
                                    <div className={'col-12 col-md-9 text-center'}>
                                        <h1 className={'custom-lead text-custom-primary'}>
                                            <FormattedMessage
                                                id="proposal.sample.preview.modal_headline_1"
                                                defaultMessage="Lead the competition, unlock your sales potential"
                                            />
                                        </h1>
                                        <h5 className="text-center">
                                            <FormattedMessage
                                                id="proposal.sample.preview.modal_sub_line"
                                                defaultMessage="Send online quotes, manage sales orders and get paid with online invoices."
                                            />
                                        </h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className={'col-12 text-center pt-3 pb-4 border-bottom'}>
                                        <a href={'https://www.quotemachine.com/sign-up?utm_medium=sample&utm_source=quote'} className={'btn btn-lg custom-btn-primary'}>
                                            <div className={'d-flex align-items-center'}>
                                                <img src="/images/QuoteM_icon_white.png" height="25px" />
                                                <span className={'ml-1'}>
                                                    <FormattedMessage
                                                        id="proposal.sample.preview.free_trial_btn"
                                                        defaultMessage="Free trial"
                                                    />
                                                </span>
                                            </div>
                                        </a>
                                        <a href={'https://www.quotemachine.com/schedule-demo?utm_medium=sample&utm_source=quote'} className={'btn btn-lg custom-btn-primary ml-3'}>
                                            <div className={'d-flex align-items-center'}>
                                                <Icon value={'desktop'} />
                                                <span className={'ml-1'}>
                                                    <FormattedMessage
                                                        id="proposal.sample.preview.schedule_a_demo_btn"
                                                        defaultMessage="Schedule a demo"
                                                    />
                                                </span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(PromoModal)





// WEBPACK FOOTER //
// ./src/proposal/sample/promomodal.component.jsx